import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router';
import { useSelector } from "react-redux";
import EmailValidationBanner from "../../components/EmailValidationBanner";
import { WELCOME_CONTENT } from "behaviour-analyzer-shared";
import appLogo from "../../resources/app.jpg";

const Dashboard = () => {
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [showPopup, setShowPopup] = useState(false);

  const { sections } = WELCOME_CONTENT;

  useEffect(() => {
    if (state.auth.user && state.auth.user.validated === false) {
      const dismissed = sessionStorage.getItem('email-validation-dismissed');
      if (!dismissed) {
        setShowPopup(true);
      }
    }
  }, [state]);

  const handleCloseModal = () => {
    setShowPopup(false);
    sessionStorage.setItem('email-validation-dismissed', 'true');
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "40px 20px",
        backgroundColor: "#f5f5f5",
        color: "#333",
      }}
    >
      {/* Banner de email no validado */}
      {showPopup && (
        <div style={{ padding: "20px", paddingTop: "10px" }}>
          <EmailValidationBanner
            visible={showPopup}
            onClose={handleCloseModal}
            onResend={() => navigate('/perfil')}
          />
        </div>
      )}

      {/* Imagen app */}
      <img
        src={appLogo}
        alt="CEAEmociones"
        style={{
          width: "min(200px, 50vw)",
          height: "min(200px, 50vw)",
          objectFit: "contain",
          marginTop: "50px",
          marginBottom: "20px",
        }}
      />

      {/* Título principal */}
      <h1
        style={{
          fontSize: "clamp(1.5rem, 5vw, 2.5rem)",
          fontWeight: "bold",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        <span style={{ color: "#e74c3c" }}>C</span>
        <span style={{ color: "#e67e22" }}>E</span>
        <span style={{ color: "#f1c40f" }}>A</span>
        <span style={{ color: "#2ecc71" }}>E</span>
        <span style={{ color: "#3498db" }}>m</span>
        <span style={{ color: "#2980b9" }}>o</span>
        <span style={{ color: "#9b59b6" }}>c</span>
        <span style={{ color: "#e74c3c" }}>i</span>
        <span style={{ color: "#e67e22" }}>o</span>
        <span style={{ color: "#f1c40f" }}>n</span>
        <span style={{ color: "#2ecc71" }}>e</span>
        <span style={{ color: "#3498db" }}>s</span>
      </h1>

      {/* Qué es CEAEmociones */}
      <section style={{ maxWidth: "800px", width: "100%", textAlign: "center", marginBottom: "40px", padding: "0 15px" }}>
        <h2 style={{ fontSize: "clamp(1.3rem, 4vw, 1.8rem)" }}>{sections.whatIs.title}</h2>
        {sections.whatIs.text.map((paragraph, i) => (
          <p key={i} style={{ fontSize: "clamp(0.9rem, 2.5vw, 1rem)", lineHeight: "1.6" }}>{paragraph}</p>
        ))}
      </section>

      {/* Cómo funciona */}
      <section style={{ maxWidth: "800px", width: "100%", textAlign: "center", marginBottom: "40px", padding: "0 15px" }}>
        <h2 style={{ fontSize: "clamp(1.3rem, 4vw, 1.8rem)" }}>{sections.howItWorks.title}</h2>
        {sections.howItWorks.text.map((paragraph, i) => (
          <p key={i} style={{ fontSize: "clamp(0.9rem, 2.5vw, 1rem)", lineHeight: "1.6" }}>
            {i === 1 ? (
              <>El acceso es de <strong>taquilla inversa</strong>, lo que significa que tú decides cuánto aportar según tus posibilidades. Incluso puedes utilizar la plataforma gratuitamente si lo necesitas.</>
            ) : paragraph}
          </p>
        ))}
      </section>

      {/* Botones de acción */}
      <div style={{
        display: "flex",
        gap: "20px",
        marginTop: "100px",
        marginBottom: "40px",
        flexWrap: "wrap",
        justifyContent: "center"
      }}>
        <button
          type="button"
          onClick={() => navigate('/modo')}
          style={{
            padding: "15px 30px",
            backgroundColor: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            fontSize: "clamp(1rem, 3vw, 1.2rem)",
            cursor: "pointer",
          }}
        >
          {WELCOME_CONTENT.startButton}
        </button>
        <button
          type="button"
          onClick={() => navigate('/sobre-el-proyecto')}
          style={{
            padding: "15px 30px",
            backgroundColor: "#3498db",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            fontSize: "clamp(1rem, 3vw, 1.2rem)",
            cursor: "pointer",
          }}
        >
          Sobre el proyecto
        </button>
      </div>
    </div>
  );
};

export default Dashboard;
